import { HttpAuth } from "../../config/Http";
import { changeAlert } from "./alert.action";
import { changeLoading } from "./loading.action";
import { changeNotify } from "./notify.action";

export const actionTypes = {
    ADD: 'ADD_CART',
    REMOVE: 'REMOVE_CART',
    INDEX: 'INDEX_CART',
    UPSELL: 'UPSELL',
    CHANGE: 'CHANGE'
};

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const addCart = (payload) => ({
    type: actionTypes.ADD,
    payload
})

export const removeCart = (payload) => ({
    type: actionTypes.REMOVE,
    payload
})

export const indexResponse = (payload) => ({
    type: actionTypes.INDEX,
    payload
})

export const changeAuto = (value, qtd, limit, min = null) => dispatch => {
    if(min) {
        if(value < min) {
            if(value > 0) {
                value = min
                dispatch(changeAlert({
                    open: true,
                    class: 'error',
                    msg: 'Quantidade miníma por compra de '+min+ ' bilhetes'
                }))
            }
            if(!value) {
                value = min
            }
        }
    }
    
    if((parseInt(value) + parseInt(qtd)) > limit) {
        dispatch(changeAlert({
            open: true,
            msg: 'Quantidade máxima de '+limit+ ((limit > 1) ? ' bilhetes' : ' bilhete') +' por compra',
            class: 'error'
        }))
    } else {
        dispatch(change({ auto: (value < 1) ? null : value }))
    }
}

export const index = () => dispatch => {
    dispatch(changeLoading({
        open: true,
        msg: 'Aguarde buscando Bilhetes reservados...'
    }))

    return HttpAuth.get('get-reservas')
    .then(res => {
        dispatch(changeLoading({ open: false }))
        dispatch(indexResponse(res.data))
    })
    .catch(error => {
        dispatch(changeLoading({
            open: false,
        }))
        dispatch(changeNotify({
            open: true,
            class: 'error',
            msg: error.response.data.msg
        }))
    })
}

export const checkoutPro = (data) => dispatch => {
    dispatch(changeLoading({
        open: true,
        msg: 'Processando...'
    }))

    return HttpAuth.post('checkout', data)
        .then(res => {
            dispatch(changeLoading({
                open: false,
            }))

            if(res.data.id) {
                return res.data;
            }
        })
        .catch(erro => {
			dispatch(changeLoading({ open: false }))
			
            if(erro.response) {
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        class: 'error',
                        msg: erro.response.data.msg,
						time: 5000
                    }))
                }
            }
		})
}

export const payment = (data) => dispatch => {
    dispatch(changeLoading({
        open: true,
        msg: 'Processando...'
    }))

    return HttpAuth.post('checkout', data)
        .then(res => {
            dispatch(changeLoading({
                open: false,
            }))
			
            if(res.data) {
                return res.data;
            }
        })
        .catch(erro => {
			dispatch(changeLoading({ open: false }))
			
            if(erro.response) {
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        class: 'error',
                        msg: erro.response.data.msg,
						time: 5000
                    }))
                }
            }
		})
}

export const upsellResponse = (payload) => ({
    type: actionTypes.UPSELL,
    payload
})

export const getUpsell = (data) => dispatch => {
    return HttpAuth.post('/upsell', data)
        .then(res => {
            if(typeof res !== 'undefined') {
                dispatch(upsellResponse(res.data))
                return res.data.upsell
            }
        })
}

export const reservaResponse = (payload) => ({
    type: actionTypes.INDEX,
    payload
})

export const reserva = (data) => dispatch => {
    dispatch(changeLoading({
        open: true,
        msg: 'Aguarde reservando Bilhete...'
    }))

    return HttpAuth.post('upsell-reserva', data)
    .then(res => {
        if(res.data.await) {
            setTimeout(() => {
                dispatch(reserva(data));
            }, 1500);
        }
        
        if(res.data.success) {
            dispatch(changeLoading({ open: false }))
    
            dispatch(changeAlert({
                open: true,
                class: 'success',
                msg: res.data.msg
            }))

            setTimeout(() => dispatch(index()), 1000)
        }
    })
    .catch(error => {
        dispatch(changeLoading({
            open: false,
        }))

        dispatch(changeAlert({
            open: true,
            class: 'error',
            msg: error.response.data.msg
        }))

        dispatch(getUpsell({rifa_id: data.rifa_id}))
    })
}